import { QuickTipsTranslation } from '@/assets/locales/views/processes/details/quickTips/quickTips.translation.en.ts';

export const quickTipsTranslation: QuickTipsTranslation = {
  quickTips: 'Wskazówki',
  uploadCv:
    'Aby szybko przesłać swoje CV, po prostu przeciągnij i upuść plik w obszarze tabeli. Alternatywnie możesz ręcznie zsynchronizować wszystkie CV z systemu, aby upewnić się, że masz dostęp do najnowszych dokumentów.',
};
